import script from "./Prize.vue?vue&type=script&setup=true&lang=js"
export * from "./Prize.vue?vue&type=script&setup=true&lang=js"

import "./Prize.vue?vue&type=style&index=0&id=3d73d5e8&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d73d5e8"]])

export default __exports__